import {BarcodeListener, BarcodeReader} from "@variocube/app-api";

export class MockBarcodeReader implements BarcodeReader {

    private barcodeListeners = new Set<BarcodeListener>();

    addBarcodeListener(listener: BarcodeListener): void {
        this.barcodeListeners.add(listener);
    }

    removeBarcodeListener(listener: BarcodeListener): void {
        this.barcodeListeners.delete(listener);
    }

    /**
     * Mocks scanning a barcode
     * @param code The binary representation of the barcode.
     */
    scanBarcode(code: string) {
        this.barcodeListeners.forEach(listener => listener({code: btoa(code)}))
    }
}